import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
import { Spinner, Table } from "reactstrap";
// import ViewIcon from "Assets/Icons/ViewIcon";
import styled from "styled-components";
// import { useNavigate } from "react-router-dom";
import "./index.css";
import ViewIcon from "Assets/Icons/ViewIcon";
import { getAPIRequest } from "utilFunctions/Axios/AxiosRequestConfiguration";
import getRequestInterface from "utilFunctions/Axios/getRequestInterface";
import { useContext } from "react";
import { ToastContextDispatch } from "Context/CommonContext";
import { BASE_URL, SINGLE_USER } from "utilFunctions/Constants/urlConstants";
import DownArrow from "Assets/Icons/downArrow30.png";
import UpArrow from "Assets/Icons/upArrow30.png";
export const returnColor = (status: string) => {
  let colorCode = "gray";
  if (status == "1") {
    colorCode = "#05945B";
  } else {
    colorCode = "#f75676";
  }
  return colorCode;
};
export const DivStyledStatus = styled<any>("div")`
  background-color: ${(props: any) => props.color};
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  display: flex;
  font-size: 12px;
  padding: 4px 11px;
  color: #ffffff;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
  width: fit-content;
`;
const tableHeading = [
  { label: "ID", value: "userId" },
  { label: "Name", value: "name" },
  { label: "Email", value: "email" },
  { label: "Employee Id", value: "employeeId" },
  { label: "Role", value: "fexRole" },
  { label: "Region", value: "region" },
  { label: "branch", value: "branch" },
  { label: "Status", value: "status" },
];
const SORT_ASC = "ASC";
const SORT_DESC = "DESC";
export interface MyUserManagementTableInterface {
  loading: boolean;
  data: any[];
  setSortColumn: any;
  sortColumn: string;
  setSortOrder: any;
  sortOrder: string;
  masters: any;
  userInfo: any;
  status: any;
  region?: any;
  setSelectedUser?: any;
  setIsOpenForm?: any;
  setFormLoading?: any;
}
const MyUserManagementTable = ({
  loading,
  data,
  sortColumn,
  setSortColumn,
  setSortOrder,
  sortOrder,
  status,
  masters,
  region,
  setSelectedUser,
  setIsOpenForm,
  setFormLoading,
}: MyUserManagementTableInterface) => {
  // const navigate = useNavigate();
  const ToastDispatch = useContext<any>(ToastContextDispatch);

  const handleSort = (column: any) => {
    sortOrder === SORT_ASC ? setSortOrder(SORT_DESC) : setSortOrder(SORT_ASC);
    setSortColumn(column);
  };
  const returnName = (array: any, id: number, name: string) => {
    console.log(name);
    return array?.find((ele: any) => ele.id == id)?.label;
  };
  const returnName2 = (array: any, id: number, name: string) => {
    console.log(name);
    return array?.find((ele: any) => ele.value == id)?.label;
  };
  const renderColumn = (column: any, id: any) => {
    switch (id) {
      case "userId":
        return <td>{column}</td>;
      case "name":
        return <td>{column}</td>;
      case "email":
        return <td>{column}</td>;
      case "employeeId":
        return <td>{column}</td>;
      case "fexRole":
        return (
          <td>
            {column !== null && column === "Branch EDP" ? "EDP Team" : column}
          </td>
        );
      case "region":
        return (
          <td>
            {column == null
              ? null
              : column.split(",").length <= 1
              ? returnName2(region, column, "region")
              : "Multiple"}
          </td>
        );
      case "branch":
        return (
          <td>
            {column == null
              ? null
              : column.split(",").length <= 1
              ? returnName(masters.branches, column, "branch")
              : "Multiple"}
          </td>
        );
      case "status":
        return (
          <td>
            <DivStyledStatus color={returnColor(column)}>
              {returnName2(status, column, "status")}
            </DivStyledStatus>
          </td>
        );
    }
  };

  const fetchSelectedUserInfo = async (url: any, userdata: any) => {
    setFormLoading(true);
    await getAPIRequest({
      url: url,
      success: (response: any) => {
        const data = response?.data;
        if (data != undefined) {
          const selectUserData = { ...userdata, ...data?.response };
          const userBranches =
            selectUserData?.branch && selectUserData?.branch != null
              ? selectUserData?.branch.split(",")
              : [];
          const userStreams =
            selectUserData?.streams && selectUserData?.streams != null
              ? selectUserData?.streams.filter((el: any) =>
                  ["SOF", "SOE", "SOM"].includes(el.stream)
                )
              : [];
          selectUserData["branch"] = userBranches;
          selectUserData["streams"] = userStreams;
          setSelectedUser({ ...selectUserData });
          setIsOpenForm(true);
          setFormLoading(false);
        }
      },
      failure: (err: any) => {
        setFormLoading(false);
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: err?.message,
        });
      },
    } as getRequestInterface);
  };
  const handleSelectedUser = (data: any, id: any) => {
    const url = BASE_URL + SINGLE_USER + "/" + id;
    fetchSelectedUserInfo(url, data);
  };
  console.log("sortColumn====", sortColumn);
  return (
    <div className="mt-3">
      {data && Array.isArray(data) && data.length === 0 ? (
        <div className="mt-4 mb-8">
          <NoResultFoundSearch
            primaryMessage="No User present"
            secondaryMessage={"We cannot found any User contents"}
          >
            <NoDataFoundIcon />
          </NoResultFoundSearch>
        </div>
      ) : (
        <div className="tableFixHead">
          <Table responsive borderless className="table table-hover">
            <thead className="table-light-custom border-top">
              <tr>
                {tableHeading.map(
                  (column: { label: string; value: string }, index: number) => {
                    return (
                      <th
                        key={index}
                        onClick={() => {
                          if (["userId", "name"].includes(column.value)) {
                            handleSort(column.value);
                          }
                        }}
                        className="tableHeadingStyle"
                      >
                        {column.label.replace("_", " ")}

                        {["userId", "name"].includes(column.value) ? (
                          <span>
                            {sortColumn == column.value &&
                            sortOrder === SORT_ASC ? (
                              <img width={16} height={12} src={UpArrow} />
                            ) : (
                              <img width={16} height={12} src={DownArrow} />
                            )}
                          </span>
                        ) : null}
                      </th>
                    );
                  }
                )}
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {!loading ? (
                data &&
                Array.isArray(data) &&
                data.map((d, index) => {
                  return (
                    <tr key={index}>
                      {tableHeading.map((column) => (
                        <>{renderColumn(d[column.value], column.value)}</>
                      ))}
                      <td>
                        <div className="actionButtonLibraryTableStyle">
                          <div
                            className="actionButtonHoverEffect mr-2"
                            onClick={() => {
                              handleSelectedUser(d, d.userId);
                            }}
                          >
                            <ViewIcon
                              id={"viewSyllabustooltip" + index}
                              data-toggle="tooltip"
                              data-trigger="hover"
                              className="cursorHoverCSS p-1"
                            ></ViewIcon>
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={tableHeading.length + 1}>
                    <div className="d-flex justify-content-center">
                      <Spinner color="info" />
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  );
};
export default MyUserManagementTable;
